module.exports = __webpack_public_path__ + "static/media/warning.f0b83d5b.svg";